import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoServiceService {

  prev_url : String; 
  constructor() { }

setUrl(url){
this.prev_url=url;
console.log("url",url);
}

getUrl(){
  return this.prev_url;
}

  // private NAVIGATE_FROM = new BehaviorSubject(0);
  // NAVIGATE_FROM_URL = this.NAVIGATE_FROM.asObservable();

  // setUserType(type: number) {
  //   this.NAVIGATE_FROM.next(type);
  // }



}
